// extracted by mini-css-extract-plugin
export default {"tooltip":"AntTooltip_tooltip__oMi6l"};